import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { vaultSecretsApiRef, VaultSecretsClient } from '@internal/backstage-plugin-vault-secrets';
import { terraformCloudApiRef, TerraformCloudClient } from '@internal/plugin-terraform-cloud';
import { claudeFlowApiRef, ClaudeFlowClient } from '@internal/plugin-claude-flow';
import { geminiAgentApiRef, GeminiAgentClient } from '@internal/plugin-gemini-agent';
import { homepageLinksApiRef, HomepageLinksClient, homepageReposApiRef, HomepageReposClient, homepageGcpProjectsApiRef, HomepageGcpProjectsClient } from '@internal/plugin-homepage-links';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  // Vault Secrets API
  createApiFactory({
    api: vaultSecretsApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
      identityApi: identityApiRef,
    },
    factory: ({ discoveryApi, fetchApi, identityApi }) =>
      new VaultSecretsClient({
        discoveryApi,
        fetchApi,
        identityApi,
      }),
  }),
  // Terraform Cloud API
  createApiFactory({
    api: terraformCloudApiRef,
    deps: {
      configApi: configApiRef,
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
      identityApi: identityApiRef,
    },
    factory: ({ configApi, discoveryApi, fetchApi, identityApi }) =>
      new TerraformCloudClient({
        configApi,
        discoveryApi,
        fetchApi,
        identityApi,
      }),
  }),
  // Claude Flow API
  createApiFactory({
    api: claudeFlowApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ discoveryApi, fetchApi }) =>
      new ClaudeFlowClient(discoveryApi, fetchApi),
  }),
  // Gemini Agent API
  createApiFactory({
    api: geminiAgentApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ discoveryApi, fetchApi }) =>
      new GeminiAgentClient(discoveryApi, fetchApi),
  }),
  // Homepage Links API
  createApiFactory({
    api: homepageLinksApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ discoveryApi, fetchApi }) =>
      new HomepageLinksClient({ discoveryApi, fetchApi }),
  }),
  // Homepage Repos API
  createApiFactory({
    api: homepageReposApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ discoveryApi, fetchApi }) =>
      new HomepageReposClient({ discoveryApi, fetchApi }),
  }),
  // Homepage GCP Projects API
  createApiFactory({
    api: homepageGcpProjectsApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ discoveryApi, fetchApi }) =>
      new HomepageGcpProjectsClient({ discoveryApi, fetchApi }),
  }),
];
